/* Auto generated by gulp-typescript-template */

export const VideoHosted = `<div class="VideoHosted content-margin"><video controls class="video-hosted [[ video ? '' : '-hidden' ]] image-responsive" alt="[[caption]]" title="[[caption]]"><source type="video/mp4"></video><div class="caption [[ caption ? '' : '-hidden' ]]">[[caption]]</div></div>`;
